export const pageSupplementaryBody = (isDetail) => `
        fragment supplementaryBody on Page {
            path
            section {
                defaultHeadlineImage {
                    aspects {
                        ratio16x9 {
                            url
                        }
                    }
                }
            }
            bannerImage {
                aspects {
                    ratio5x1 {
                        url
                    }
                    ratioCustom {
                        url
                    }
                }
            }
            ${
                !isDetail
                    ? ` sections{
                right{
                    content{
                        ...PageNode
                    }
                }
            }`
                    : ``
            }

        }
    `;

export const pageBody = (isPreview) => `
    fragment body on Page {
        ${!isPreview ? "id" : ""}
        title
        description
        pageHeading: heading
        headingVisible
        path
        navigation
        section {
            defaultHeadlineImage {
                aspects {
                    ratio16x9 {
                        url
                    }
                }
            }
            tracking {
                ...TrackingNode
            }
            attributionLevels
        }
        bannerImage {
                aspects {
                    ratio5x1 {
                        url
                    }
                    ratioCustom {
                        url
                    }
                }
        }
        sections{
            main {
                layout
                content {
                    ...PageNode
                }
            }
            right {
                content{
                    ...PageNode
                }
            }
        }
        metadata {
            description
        }
    }
`;

export const widgetNode = `
fragment widgetNode on ContentItem{
    sourceId
    type
    pageWidget  {
        metadata
        payload {
            items {
                ...cardNode
            }
        }
    }
}`;

export const PageNode = `
fragment PageNode on PageElement {
    ... on PageLineup {
        type
        lineup {
            pubQueueId
            slug
        }
        wrapper {
            sourceId
            size
            heading {
              title
              description
              visible
            }
            link {
              url
              title
              visible
            }
            loadMoreContent
            loadMoreSize
            startAt
            attribution {
                featureInstance
            }
            displayContentPackage
        }
        content{
            ...cardNode
        }
    }

    ... on ContentItem {
        ...widgetNode
    }
}`;

export const TrackingNode = `
fragment TrackingNode on SectionTracking{
    subSection1
    subSection2
    subSection3
    subSection4
    contentArea
}
`;
